import React, { useEffect } from 'react';
import TableView from '../Table/Table';
import { tableHeadings } from '../../../utils/constants';
import { fetchTerminalBatchData, closeProcessorTerminalBatch, setLoadingBatchData } from '../../../redux/actions/ProcessorTerminalActions';
import { connect } from "react-redux";
import { Panel, PanelHeader } from '../../header/panel/panel';


const ProcessorTerminalBatchList = (props) => {



    useEffect(() => {
        props.fetchTerminalBatchData(props.processorTermID)

    }, [props.PROCESSORTERMINALREDUCER.loadingBatchData])


    const handleBatchClose = (event) => {

        event.preventDefault();

        let body = {}

        if (props.processorTermID) {
            body.processorTermID = props.processorTermID
            body.closeBatch = true
        }

        if (body.processorTermID) {

            props.setLoadingBatchData(true)
            props.closeProcessorTerminalBatch(body)
        }

    }

    const handleTrailBatchClose = (event) => {

        event.preventDefault();

        let body = {}

        if (props.processorTermID) {
            body.processorTermID = props.processorTermID
            body.settle = false
        }


        if (body.processorTermID) {

            props.setLoadingBatchData(true)
            props.closeProcessorTerminalBatch(body)

        }

    }



    return (

        <Panel>

            <PanelHeader>
                <div className="row mb-0">

                    <div className="col-xl-8">
                        Terminal Batch List
                    </div>
                    <div className="col-xl-2">
                        <button className='btn btn-xs btn-secondary d-block w-40 btn-lg fs-09px' onClick={handleTrailBatchClose}>Test Batch</button>

                    </div>
                    <div className="col-xl-2">
                        <button className='btn btn-xs btn-secondary d-block w-40 btn-lg fs-09px' onClick={handleBatchClose}>Close Batch</button>
                    </div>
                </div>
            </PanelHeader>

            <TableView height={357} count={7} headings={tableHeadings.processorTerminalBatchTotals} data={props.PROCESSORTERMINALREDUCER.terminalBatchData} />

        </Panel>


    )

}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchTerminalBatchData,
    closeProcessorTerminalBatch,
    setLoadingBatchData
}


export default connect(mapStateToProps, mapDispatchToProps)(ProcessorTerminalBatchList);